import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Card } from 'antd';

interface InventoryAgeChartProps {
    distribution: { name: string; value: number }[];
    loading?: boolean;
}

export const InventoryAgeChart: React.FC<InventoryAgeChartProps> = ({ distribution, loading }) => {
    const getOption = () => ({
        title: { text: 'FBA库龄分布', left: 'center' },
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
        legend: { bottom: 10 },
        series: [{
            name: '库存数量', type: 'pie', radius: ['40%', '70%'],
            data: distribution,
            emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' } }
        }]
    });

    return (
        <Card title="库存健康度 (库龄)" loading={loading}>
            <ReactECharts option={getOption()} style={{ height: 300 }} />
        </Card>
    );
};
